export default __webpack_public_path__ + "static/media/enable-cam-safari-mac.f25b60ac.png";